// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"_1rk3E","greyCard":"tY3AY","heading":"_2MnCg","label":"_2hQWg","edit":"_3-v3s","variant":"K9Ufi"};